import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoArrowDown, LazySvgoArrowLeft, LazySvgoArrowRight, LazySvgoArrowUp, LazySvgoAttention, LazySvgoBag, LazySvgoClose, LazySvgoComment, LazySvgoCommunication, LazySvgoCookie, LazySvgoDownload, LazySvgoEyeClose, LazySvgoEyeOpen, LazySvgoFb, LazySvgoFileBig, LazySvgoFilePlay, LazySvgoFile, LazySvgoFilter, LazySvgoHistory, LazySvgoHome, LazySvgoImplant, LazySvgoInnovation, LazySvgoInstagram, LazySvgoInvoiceCheck, LazySvgoLink, LazySvgoLinkedin, LazySvgoMagnify, LazySvgoMenu, LazySvgoPencil, LazySvgoPicture, LazySvgoPlus, LazySvgoPrice, LazySvgoStar, LazySvgoTick, LazySvgoZoomIn, LazySvgoZoomOut } from '#components'
const lazyGlobalComponents = [
  ["SvgoArrowDown", LazySvgoArrowDown],
["SvgoArrowLeft", LazySvgoArrowLeft],
["SvgoArrowRight", LazySvgoArrowRight],
["SvgoArrowUp", LazySvgoArrowUp],
["SvgoAttention", LazySvgoAttention],
["SvgoBag", LazySvgoBag],
["SvgoClose", LazySvgoClose],
["SvgoComment", LazySvgoComment],
["SvgoCommunication", LazySvgoCommunication],
["SvgoCookie", LazySvgoCookie],
["SvgoDownload", LazySvgoDownload],
["SvgoEyeClose", LazySvgoEyeClose],
["SvgoEyeOpen", LazySvgoEyeOpen],
["SvgoFb", LazySvgoFb],
["SvgoFileBig", LazySvgoFileBig],
["SvgoFilePlay", LazySvgoFilePlay],
["SvgoFile", LazySvgoFile],
["SvgoFilter", LazySvgoFilter],
["SvgoHistory", LazySvgoHistory],
["SvgoHome", LazySvgoHome],
["SvgoImplant", LazySvgoImplant],
["SvgoInnovation", LazySvgoInnovation],
["SvgoInstagram", LazySvgoInstagram],
["SvgoInvoiceCheck", LazySvgoInvoiceCheck],
["SvgoLink", LazySvgoLink],
["SvgoLinkedin", LazySvgoLinkedin],
["SvgoMagnify", LazySvgoMagnify],
["SvgoMenu", LazySvgoMenu],
["SvgoPencil", LazySvgoPencil],
["SvgoPicture", LazySvgoPicture],
["SvgoPlus", LazySvgoPlus],
["SvgoPrice", LazySvgoPrice],
["SvgoStar", LazySvgoStar],
["SvgoTick", LazySvgoTick],
["SvgoZoomIn", LazySvgoZoomIn],
["SvgoZoomOut", LazySvgoZoomOut],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
